import React, { useState, useEffect } from 'react';
import { FaClock, FaTimes } from 'react-icons/fa';

const NetherGamesBanner = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Target date: June 28th, 2026 00:00:00 UTC
    // Note: Months in JS are 0-indexed, so 5 is June.
    const targetDate = new Date(Date.UTC(2026, 5, 28, 12, 0, 0)).getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      });
    };

    updateTimer(); // Initial call to avoid 1s delay
    const timerId = setInterval(updateTimer, 1000);

    return () => clearInterval(timerId); // Cleanup on unmount
  }, []);

  if (!isVisible) return null;

  // Format numbers to always be 2 digits (e.g., "09" instead of "9")
  const formatNum = (num) => String(num).padStart(2, '0');

  return (
    <div className="bg-gradient-to-r from-orange-600 via-orange-500 to-orange-600 text-white px-3 py-1.5 flex items-center justify-center relative w-full shadow-sm z-50 text-[11px] sm:text-xs">
      <div className="flex items-center space-x-1.5 sm:space-x-2 font-medium">
        <FaClock className="text-white/90 shrink-0" />
        <span>
          NetherGames will be closing in{' '}
          <span className="font-bold tabular-nums tracking-wide bg-black/10 px-1.5 py-0.5 rounded">
            {formatNum(timeLeft.hours)}h {formatNum(timeLeft.minutes)}m {formatNum(timeLeft.seconds)}s
          </span>
        </span>
      </div>
      
      {/* Dismiss Button */}
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-2 p-1 hover:bg-black/10 rounded transition-colors"
        aria-label="Dismiss banner"
      >
        <FaTimes className="text-white/90 w-3 h-3" />
      </button>
    </div>
  );
};

export default NetherGamesBanner;
